import {uniqBy} from "lodash"
import {ApolloState} from "../apolloStateInterface"

type QueryVariables = {
  query: any
  variables: {[key: string]: any}
}

export default function cursorPagination({query, variables}: QueryVariables, {data, fetchMore}: ApolloState, key = Object.keys(data)[0]) {
  if (data[key].count === data[key].results.length) {
    return Promise.resolve(data)
  }

  return fetchMore({
    query,
    variables,
    updateQuery: (previousResult: any, {fetchMoreResult}: any) => {
      const oldFeed = previousResult[key].results
      const newFeed = uniqBy([...oldFeed, ...fetchMoreResult[key].results], "uuid")

      return {
        [key]: {
          ...fetchMoreResult[key],
          results: newFeed
        }
      }
    }
  })
}
